module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Grayzel3_Side.91a415c7.png";